const SET_REPORT_TYPE = (state, payload) => {
  state.reportType = payload;
};

const SET_REPORT_TEMPLATE_LIST = (state, payload) => {
  state.reportTemplateList = payload;
};

const REMOVE_REPORT_TEMPLATE = (state, id) => {
  const { reportTemplateList } = state;
  const reportTemplateIdx = reportTemplateList.findIndex(item => item.id === id);

  reportTemplateList.splice(reportTemplateIdx, 1);
};

const SET_CURRENT_EDITING_TEMPLATE = (state, template) => {
  state.currentEditingTemplate = template;
};

export default {
  SET_REPORT_TYPE,
  SET_REPORT_TEMPLATE_LIST,
  REMOVE_REPORT_TEMPLATE,
  SET_CURRENT_EDITING_TEMPLATE,
};
